import { billingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress";
import { shippingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress";
import { orderHistoryPaginationStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryPagination";
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { searchFormStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import { orderHistoryTableStyles } from "../Overrides/Widgets/OrderHistory/OrderHistoryTable";

orderHistoryPaginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            margin: 0 !important;
            select {
                font-size: 14px !important;
            }
        `,
        perPageSelect: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            justify-content: flex-start;
                        `,
                        css`
                            width: 30%;
                            justify-content: flex-start;
                        `,
                        css`
                            width: 30%;
                            justify-content: flex-start;
                        `,
                    ],
                    "max",
                )}
            > div {
                padding: 0;
                width: auto;
                label {
                    width: auto;
                    font-size: 12px;
                    padding-top: 11px;
                    padding-right: 0;
                    text-transform: uppercase;
                    & + div {
                        width: auto;
                        select {
                            padding-right: 30px !important;
                            border-width: 0 !important;
                        }
                    }
                }
            }
        `,
        linkList: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            justify-content: flex-end;
                        `,
                        css`
                            justify-content: flex-end;
                        `,
                        css`
                            width: 70%;
                            justify-content: flex-end;
                        `,
                    ],
                    "max",
                )}
            ul li {
                button {
                    max-width: 30px;
                    width: 18px;
                    padding: 0;
                    span {
                        font-size: 12px;
                        color: #353432;
                    }
                }
            }
        `,
        currentButton: css`
            width: 20px;
            height: 20px;
            padding: 0px;
            color: #59b46c;
            background-color: white;
            border: 0.5px solid #011efb;
            & span {
                color: #011efb !important;
            }
            &:hover {
                background-color: #fff !important;
                color: #59b46c !important;
                border: 0.5px solid #59b46c;
            }
        `,
    },
};
dateRangeStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-left: 10px;
        `,
    },
    labelProps: {
        css: css`
            color: #0f0f0f;
        `,
    },
};

billingAddressStyles.titleText = {
    css: css`
        font-size: 20px;
        margin-bottom: 5px;
        font-weight: 700;
    `,
};

shippingAddressStyles.titleText = {
    css: css`
        font-size: 20px;
        margin-bottom: 5px;
        font-weight: 700;
    `,
};

// clear filter button
searchFormStyles.wrapper = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    margin-bottom: 10px;
                    > div[class^="Wrapper"] {
                        > div[class^="GridWrapper"]:last-child {
                            position: relative;
                            > div[class^="GridOffset"] {
                                >div: last-child {
                                    align-items: flex-end;
                                    position: absolute;
                                    right: 0;
                                    bottom: 0;
                                    padding: 10px;
                                }
                            }
                        }
                    }
                `,
                css`
                    margin-bottom: 10px;
                    > div[class^="Wrapper"] {
                        > div[class^="GridWrapper"]:last-child {
                            position: relative;
                            > div[class^="GridOffset"] {
                                >div: last-child {
                                    align-items: flex-end;
                                    position: absolute;
                                    right: 0;
                                    bottom: 0;
                                    padding: 10px;
                                    top: 40px;
                                }
                            }
                        }
                    }
                `,
                css`
                    margin-bottom: 10px;
                    > div[class^="Wrapper"] {
                        > div[class^="GridWrapper"]:last-child {
                            > div[class^="GridOffset"] {
                                >div: last-child {
                                    align-items: flex-end;
                                }
                            }
                        }
                    }
                `,
            ])}
    `,
};

orderHistoryTableStyles.dataTable = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    margin-top: 60px;
                `,
                null,
            ])}
    `,
};
